/** Extract a string from axios interceptor rejections (IErrorModel) or raw errors. */
export function apiErrorToastMessage(err: unknown, fallback: string): string {
    const e = err as { errorMessage?: unknown; message?: unknown; response?: { data?: { message?: unknown } } };
    const raw = e?.errorMessage ?? e?.response?.data?.message ?? e?.message;
    if (typeof raw === 'string' && raw.trim()) {
        return raw.trim();
    }
    if (raw && typeof raw === 'object') {
        const parts = Object.values(raw as Record<string, unknown>).filter((v) => typeof v === 'string') as string[];
        if (parts.length > 0) {
            return parts.join('. ');
        }
    }
    return fallback;
}

/** Prefer backend user-facing text; use only when the API omits a message. */
export function connectionTestToastMessage(message?: string | null): string {
    return message?.trim() || 'Connection test failed. Check the message and try again.';
}

export function pollToastMessage(message?: string | null, code?: string): string {
    return message?.trim() || (code ? `Download finished for ${code}.` : 'Download finished.');
}

export function sendTestToastMessage(message?: string | null, code?: string): string {
    return message?.trim() || (code ? `Send test finished for ${code}.` : 'Send test finished.');
}

export function wizardErrorMessage(err: unknown, fallback: string): string {
    return apiErrorToastMessage(err, fallback);
}
